export class UrlHelper
{
    public static get SiteBaseUrl(): string
    {
        return UrlHelper.IsLocal ? "https://local.urlo.site" : "https://urlo.site";
    }

    public static get AppBaseUrl(): string
    {
        return UrlHelper.IsLocal ? "https://app.local.urlo.site" : "https://app.urlo.site";
    }

    public static get IsLocal(): boolean
    {
        return location.hostname === 'localhost'
            || location.hostname.endsWith('.local')
            || location.hostname.startsWith('local.')
            || location.hostname.startsWith('app.local.');
    }
}
